import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "levelOneTable", "levelTwoTable", "sysUserTable",
    "sysUserActions", "sysUserNewAction",
    "sysUserViewBtn", "sysUserEditBtn", "sysUserDeleteBtn", "deleteSysUserForm", "sysUserNewBtn"
  ]

    connect() {
        this.selectedLevelOneId = null
        this.selectedLevelTwoId = null

        const showLevelOne = this.element.dataset.showLevelOne === 'true'
        if (!showLevelOne) {
        this.loadLevelTwos()
        }
    }

    loadLevelTwos(levelOneId = null) {
        const url = levelOneId
        ? `/contractor_hierarchy/level_twos?level_one_id=${levelOneId}`
        : `/contractor_hierarchy/level_twos`

        fetch(url)
        .then(res => res.json())
        .then(data => this.renderLevelTwoTable(data))
    }

    levelOneClick(event) {
        event.preventDefault()
        const id = event.currentTarget.dataset.levelOneId
        const code = event.currentTarget.dataset.levelOneCode
        this.selectedLevelOneId = id
        this.selectedLevelTwoId = null

        this.levelOneTableTarget.querySelectorAll('[data-level-one-id]').forEach(el => {
        el.closest('tr').classList.remove('bg-opacity-25', 'bg-primary')
        })
        event.currentTarget.closest('tr').classList.add('bg-opacity-25', 'bg-primary')

        this.sysUserTableTarget.querySelector('tbody').innerHTML = '<tr><td colspan="2" class="text-center text-muted py-5">該当データはありません。</td></tr>'
        this.sysUserActionsTarget.classList.add('d-none')

        this.sysUserNewActionTarget.classList.remove('d-none')
        this.sysUserNewBtnTarget.href = `/contractor_hierarchy/new?org_code=${code}`

        this.loadLevelTwos(id)
        this.loadSysUsers({ level_one_id: id })
    }

    renderLevelTwoTable(data) {
        const tbody = this.levelTwoTableTarget.querySelector('tbody')
        tbody.innerHTML = ''

        if (data.length === 0) {
        tbody.classList.remove('border-bottom')
        tbody.innerHTML = '<tr><td colspan="2" class="text-center text-muted py-5">該当データはありません。</td></tr>'
        return
        }

        tbody.classList.add('border-bottom')
        data.forEach(item => {
        tbody.innerHTML += `
            <tr class="cursor-pointer" data-level-two-id="${item.id}" data-level-two-code="${item.level_two_code}" data-action="click->contractor-hierarchy#levelTwoClick">
                <td class="px-5 py-4">
                    <div class="text-primary-two fs-5 fw-bolder">
                        ${item.level_two_code}
                    </div>
                    <div class="d-flex justify-content-between py-1">
                        <h6 class="fs-6 fw-normal m-0 text-truncate">
                        ${item.name}
                        </h6>
                    </div>

                    <div class="d-flex mt-2">
                        <div class="border border-primary border-dashed rounded w-100 py-2 px-4 me-4">
                            <div class="fs-3 text-primary fw-bolder text-end">
                                ${item.app_users_count || 0}
                            </div>
                            <div class="fw-bolder fs-7 text-primary text-end">
                                アプリユーザー数
                            </div>
                        </div>

                        <div class="border border-primary border-dashed rounded w-100 py-2 px-4">
                            <div class="fs-3 text-primary fw-bolder text-end">
                                ${item.sys_users_count || 0}
                            </div>
                            <div class="fw-bolder fs-7 text-primary text-end">
                                担当者数
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        `
        })
    }

    levelTwoClick(event) {
        event.preventDefault()
        const id = event.currentTarget.dataset.levelTwoId
        const code = event.currentTarget.dataset.levelTwoCode
        this.selectedLevelTwoId = id

        this.levelTwoTableTarget.querySelectorAll('[data-level-two-id]').forEach(el => {
        el.closest('tr').classList.remove('bg-opacity-25', 'bg-primary')
        })
        event.currentTarget.closest('tr').classList.add('bg-opacity-25', 'bg-primary')

        this.sysUserActionsTarget.classList.add('d-none')
        this.sysUserNewActionTarget.classList.remove('d-none')
        this.sysUserNewBtnTarget.href = `/contractor_hierarchy/new?org_code=${code}`

        this.loadSysUsers({ level_two_id: id })
    }

    loadSysUsers(params) {
        const query = new URLSearchParams(params).toString()
        fetch(`/contractor_hierarchy/sys_users?${query}`)
        .then(res => res.json())
        .then(data => this.renderSysUserTable(data))
    }

    renderSysUserTable(data) {
        const tbody = this.sysUserTableTarget.querySelector('tbody')
        tbody.innerHTML = ''

        if (data.length === 0) {
        tbody.classList.remove('border-bottom')
        tbody.innerHTML = '<tr><td colspan="2" class="text-center text-muted py-5">該当データはありません。</td></tr>'
        return
        }

        tbody.classList.add('border-bottom')
        data.forEach(user => {
        tbody.innerHTML += `
            <tr class="cursor-pointer" data-sys-user-id="${user.id}" data-action="click->contractor-hierarchy#sysUserClick">
                <td class="fs-6 ps-4">
                    <span class="text-primary-two fs-5 fw-bolder d-block">${user.org_code}-${user.sys_user_code}</span>
                    <span class="text-gray-800 fw-normal d-block py-1">${user.name}</span>
                </td>
            </tr>
        `
        })
    }

    sysUserClick(event) {
        event.preventDefault()

        this.sysUserTableTarget.querySelectorAll('[data-sys-user-id]').forEach(el => {
        el.classList.remove('bg-opacity-25', 'bg-primary')
        })
        event.currentTarget.classList.add('bg-opacity-25', 'bg-primary')

        const userId = event.currentTarget.dataset.sysUserId

        this.sysUserNewActionTarget.classList.add('d-none')
        this.sysUserActionsTarget.classList.remove('d-none')
        this.sysUserViewBtnTarget.href = `/contractor_hierarchy/${userId}`
        this.sysUserEditBtnTarget.href = `/contractor_hierarchy/${userId}/edit`
        this.deleteSysUserFormTarget.action = `/contractor_hierarchy/${userId}`
    }
}